// Smart Routing middleware endpoints (see "Smart Routing" Postman collection).
//
// Every function resolves to the middleware envelope
//   { success, errorcode, message, result }
// and never throws: transport/HTTP failures are normalized into a failed
// envelope, so callers have a single code path.
import { middleware } from "@/services/http";

// list_type values the middleware understands.
export const LIST_TYPES = Object.freeze({
  VIP: 1,
  BLACKLIST: 2,
});

async function unwrap(request) {
  try {
    const response = await request;
    return (
      response?.data ?? {
        success: false,
        errorcode: 0,
        message: "",
        result: null,
      }
    );
  } catch (err) {
    return {
      success: false,
      errorcode: err.response?.status ?? 0,
      message: err.response?.data?.message || err.message,
      result: null,
    };
  }
}

// Configure last-agent routing. An empty `queue` applies to all queues.
export function setLastAgentRouteConf({ enabled, window, queue }) {
  return unwrap(
    middleware.post(
      "/SetLastAgentRouteConf",
      JSON.stringify({ enabled, window, queue }),
      { headers: { request: "SetLastAgentRouteConf" } }
    )
  );
}

// List numbers of a list. limit=0 means no limit; `number` filters server-side.
export function getNumbersFromList({
  listType,
  limit = 0,
  offset = 0,
  number = "",
}) {
  const params = new URLSearchParams({
    list_type: listType,
    limit,
    offset,
    number,
  });
  return unwrap(
    middleware.get("/GetNumbersFromList?" + params.toString(), {
      headers: { request: "GetNumbersFromList" },
    })
  );
}

// VIP entries carry a priority (higher = served earlier); blacklist entries
// carry an optional comment.
export function addNumberToList({ number, listType, priority, comment }) {
  const body = { number, list_type: listType };
  if (listType === LIST_TYPES.VIP) {
    body.priority = priority;
  } else {
    body.comment = comment || "";
  }
  return unwrap(
    middleware.post("/AddNumberToList", JSON.stringify(body), {
      headers: { request: "AddNumberToList" },
    })
  );
}

export function updateVipNumberPriority({ id, priority }) {
  return unwrap(
    middleware.post(
      "/UpdateVIPNumberPriority",
      JSON.stringify({ id, priority }),
      { headers: { request: "UpdateVIPNumberPriority" } }
    )
  );
}

export function deleteNumberFromList({ id, listType }) {
  return unwrap(
    middleware.post(
      "/DeleteNumberFromList",
      JSON.stringify({ id, list_type: listType }),
      { headers: { request: "DeleteNumberFromList" } }
    )
  );
}
